module.exports = __webpack_public_path__ + "static/media/BurbankBigCondensed-Bold.f2574a77.woff2";